import React from 'react'
import { connect } from 'react-redux'

import { BnblPackageDuration } from './BnblPackageDuration'
import { Divider } from './Divider'
import { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import { OfferPackageOptionView } from 'selectors/offerPageSelectors'
import { BnblPackageImageAndName } from './BnblPackageImageAndName'
import BnblPackageRooms from './BnblPackageRooms'

interface MappedProps {
  packageView: OfferPackageOptionView;
}

interface Props {
  offer: App.Offer;
  setStep: (step: BnblSteps) => void;
}

function BnblOneRoomPackage({
  offer,
  packageView,
  setStep,
}: Props & MappedProps) {
  const { id: offerId, image } = offer
  const { duration, name: packageName, roomType: { name: roomTypeName }, uniqueKey } = packageView.package

  return (
    <>
      <BnblPackageImageAndName
        image={image}
        packageName={packageName}
        roomTypeName={roomTypeName}
      />
      <BnblPackageDuration
        duration={duration}
        setStep={setStep}
      />
      <Divider />
      <BnblPackageRooms
        offerId={offerId}
        packageKey={uniqueKey}
      />
    </>
  )
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  const bnblModalPackages = state.offer.bnblModal[ownProps.offer.id]
  const { packageView } = bnblModalPackages[0]
  return {
    packageView,
  }
}

export default connect(mapStateToProps)(BnblOneRoomPackage)
